import React, { JSX } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

interface Props {
  isOpen: boolean;
  itemToDisplay: React.ReactNode;
  toggle: () => void;
  title?: string;
  className?: string;
  size?: string;
  id?: string;
}

function BasicModal(props: Props): JSX.Element {
  const { isOpen, itemToDisplay, toggle, title, className, size, id } = props;

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size={size || 'lg'}
        modalClassName={className}
        scrollable
      >
        {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
        <ModalBody id={id}>{itemToDisplay}</ModalBody>
      </Modal>
    </>
  );
}

export default BasicModal;
